import { render, staticRenderFns } from "./ForceNewsBlockWrapper.vue?vue&type=template&id=2c888f52&scoped=true"
import script from "./ForceNewsBlockWrapper.vue?vue&type=script&lang=js"
export * from "./ForceNewsBlockWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c888f52",
  null
  
)

export default component.exports